import { PipeTransform } from '@angular/core';
import { ContentParser } from '../content.parser';
var ContentParsePipe = /** @class */ (function () {
    function ContentParsePipe(parser) {
        this.parser = parser;
    }
    ContentParsePipe.prototype.transform = function (value) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var params = this.interpolateParams(args);
        return this.parser.interpolate(value, params);
    };
    ContentParsePipe.prototype.interpolateParams = function (args) {
        var interpolateParams;
        if (args[0] != null && args.length) {
            if (typeof args[0] === 'string' && args[0].length) {
                // we accept objects written in the template such as {n:1}, {'n':1}, {n:'v'}
                // which is why we might need to change it to real JSON objects such as {"n":1} or {"n":"v"}
                var validArgs = args[0]
                    .replace(/(\')?([a-zA-Z0-9_]+)(\')?(\s)?:/g, '"$2":')
                    .replace(/:(\s)?(\')(.*?)(\')/g, ':"$3"');
                try {
                    interpolateParams = JSON.parse(validArgs);
                }
                catch (e) {
                    throw new SyntaxError("Wrong parameter in TranslatePipe. Expected a valid Object, received: " + args[0]);
                }
            }
            else if (typeof args[0] === 'object' && !Array.isArray(args[0])) {
                interpolateParams = args[0];
            }
        }
        return interpolateParams;
    };
    return ContentParsePipe;
}());
export { ContentParsePipe };
